import React from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";

import AuthLayout from "components/layout/AuthLayout";

const sx = {
  root: {
    overflowY: "scroll",
    height: "100%"
  },
  wrap: {
    display: "flex"
  },
  main: {
    flexGrow: "1",
    overflow: "hidden"
  }
};

const AuthLayoutPage = () => {
  return (
    <Box sx={sx.root}>
      <Box sx={sx.wrap}>
        <AuthLayout />
        <Box sx={sx.main}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AuthLayoutPage;
